import React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { Formik } from 'formik';
import { Field } from 'formik';
import { KeyboardDatePicker } from 'formik-material-ui-pickers';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { formatDate } from '../../../utils';
import * as yup from 'yup';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ConfirmOrCancelButtons from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Actions/ConfirmOrCancelButtons';
import moment from 'moment';

const useStyles = makeStyles((theme: any) => ({
  explanationTitle: {
    fontWeight: 700,
    lineHeight: 1.2,
    marginTop: theme.spacing(3),
  },
  explanationText: {
    lineHeight: 1.25,
    marginTop: theme.spacing(1),
  },
  dateInput: {
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(4),
    width: 175,
  },
}));

interface Props {
  initialDate: string;
  handleClose: (...args) => void;
}

export default function DialogContent({ initialDate, handleClose }: Props) {
  const classes = useStyles();
  const { duplicateLineSubmit } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();

  return (
    <Formik
      initialValues={{ startDate: moment.utc(initialDate) }}
      validationSchema={yup.object({
        startDate: yup.date().required(),
      })}
      onSubmit={({ startDate }) => {
        const startDateMoment = moment.utc(startDate);
        const eventName =
          formatDate(startDateMoment) === initialDate
            ? 'duplicate_line_as_is'
            : 'duplicate_line_&_shift_forward';
        trackEvent({
          event: eventName,
        });
        duplicateLineSubmit(startDateMoment);
        handleClose();
      }}
      component={({ submitForm }) => {
        return (
          <>
            <Typography variant="h6" className={classes.explanationTitle}>
              Choose a start date
            </Typography>
            <Typography variant="body1" className={classes.explanationText}>
              This designates where your Line starts on the calendar. Stages can
              be further customized after the Line is created.
            </Typography>
            <Field
              component={KeyboardDatePicker}
              label="Line start date"
              disableToolbar
              disablePast
              autoOk
              variant="inline"
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'start' }}
              name="startDate"
              format="MM/dd/yy"
              placeholder="mm/dd/yyyy"
              className={classes.dateInput}
            />
            <ConfirmOrCancelButtons
              cancel={{ label: 'Cancel', action: handleClose }}
              confirm={{
                label: 'Create Line',
                action: submitForm,
              }}
            />
          </>
        );
      }}
    />
  );
}
